module.exports = __webpack_public_path__ + "img/balkon.2c90ce86.webp";